<template>
  <div class="content_main">
    <div style="margin-top: 10px">
      <!-- <a-button type="primary" @click="application"> 其他费用申请 </a-button> -->
      <a-button type="primary" @click="exp"> 数据导出 </a-button>
    </div>
    <div class="content_main_top">
      <a-input
        allowClear
        class="a_input_self margin_self"
        v-model="queryParam.applyCode"
        placeholder="审批编号"
        @keyup.enter.native="query"
      />
      <a-input
        allowClear
        class="a_input_self margin_self"
        v-model="queryParam.applyUserName"
        placeholder="申请人"
        @keyup.enter.native="query"
      />
      <a-range-picker
        valueFormat="YYYY-MM-DD"
        style="margin-right: 10px; width: 240px"
        allowClear
        :value="dates"
        @change="onChange"
        @keyup.enter.native="query"
        :placeholder="['申请开始时间', '申请结束时间']"
      />
      <a-select
        placeholder="审批状态"
        class="a_input_self margin_self"
        v-model="queryParam.status"
        default-value="0"
        @keyup.enter.native="query"
      >
        <a-select-option :value="''">全部</a-select-option>
        <a-select-option v-for="(val, key) in status_apply" :key="key" :value="key">{{ val.txt }}</a-select-option>
      </a-select>
      <a-select
        placeholder="审批结果"
        class="a_input_self margin_self"
        v-model="queryParam.result"
        default-value="0"
        @keyup.enter.native="query"
      >
        <a-select-option :value="''">全部</a-select-option>
        <a-select-option v-for="(val, key) in resultMap" :key="key" :value="key">{{ val }}</a-select-option>
      </a-select>
      <a-button type="primary" @click="query"> 查询 </a-button>
      <a-button type="primary" ghost @click="result"> 重置 </a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table
        :columns="columns"
        :data-source="data"
        bordered
        :pagination="pagination"
        @change="handleTableChange"
        :scroll="{ y: scroll_y }"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </span>
        <span slot="status" slot-scope="text" class="tag_class" :style="{ background: status_apply[text].color }">
          {{ status_apply[text].txt }}
        </span>
        <span slot="result" slot-scope="text" class="tag_class" :style="{ background: result_apply[text].color }">
          {{ result_apply[text].txt }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handelAudit(record)">详情</a>
          <a-divider type="vertical" />
          <a @click="handFlow(record)">历史</a>
          <a-divider type="vertical" />
          <a :disabled="record.status !== 1" @click="cancel([record.procInstId])">撤销</a>
          <!-- <a-divider type="vertical" />
					<a :disabled="record.status === 1" @click="delByIds([record.buId])">删除</a> -->
        </span>
      </a-table>
    </div>
    <proc-flow-modal ref="modalflow" />
    <other-modal ref="othermodal" :audit="false" />
    <other-application ref="otherapplication" @ok="handleOk" />
  </div>
</template>

<script>
import { other_apply_list } from '@/api/financial'
import { delProcessIns, delBusiness } from '@/api/activiti'
import ProcFlowModal from '../activiti/modules/ProcFlowModal.vue'
import otherModal from '../activiti/modules/otherModal.vue'
import OtherApplication from '@/components/module/OtherApplication'
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    width: 70,
    ellipsis: true,
  },
  {
    title: '审批编号',
    dataIndex: 'otherCode',
    key: 'otherCode',
    ellipsis: true,
  },
  {
    title: '申请人',
    dataIndex: 'userName',
    key: 'userName',
    ellipsis: true,
  },
  {
    title: '申请时间',
    dataIndex: 'createTime',
    key: 'createTime',
    ellipsis: true,
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
  },
  {
    title: '审批结果',
    dataIndex: 'result',
    key: 'result',
    scopedSlots: {
      customRender: 'result',
    },
    ellipsis: true,
  },
  {
    title: '审批状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: {
      customRender: 'status',
    },
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: {
      customRender: 'action',
    },
  },
]
export default {
  components: {
    ProcFlowModal,
    otherModal,
    OtherApplication,
  },
  data() {
    return {
      columns,
      scroll_y: 150,
      dept_id: '',
      code: '',
      asset_sn: '',
      headers: {},
      fileList: [],
      removeList: [],
      defaultFileList: [],
      file_name: '',
      upload: {
        asset_sn: '',
        dept_id: '',
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      labelCol2: {
        span: 2,
      },
      wrapperCol2: {
        span: 22,
      },
      isRouterAlive: true,
      queryParam: {},
      dates: [],
    }
  },
  created() {
    this.get_sel()
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 100
      }, 1000)
    })
  },
  methods: {
    handleOk() {
      this.get_sel()
    },
    handelAudit(record) {
      console.log(record, 'record++++++++++++')
      this.$refs.othermodal.show({
        businessKey: record.buId,
        procInstId: record.procInstId,
        procDefKey: 'other-charge',
        recordNumber: 1
      })
    },
    //历史
    handFlow(row) {
      var obj = {
        procInstId: row.procInstId,
        procDefKey: row.procDefKey,
      }
      this.$refs.modalflow.show(obj)
    },
    // 撤销
    cancel(ids) {
      console.log(ids)
      // const idstr = ids.map(r => { return '\'' + r + '\'' }).join('')
      delProcessIns({
        ids: ids.join(','),
        reason: '主动撤销',
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('撤销成功')
          this.get_sel()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    delByIds(ids) {
      // const idstr = ids.map(r => { return '\'' + r + '\'' }).join('')
      delBusiness({
        ids: ids.join(','),
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.get_sel()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    costChange(index, date) {
      this.form.pays[index].reviewDate = date
    },
    onChange(date, dateString) {
      this.dates = date
      this.queryParam.start_date = date[0]
      this.queryParam.end_date = date[1]
    },
    application() {
      this.$refs.otherapplication.show()
    },
    get_sel() {
      other_apply_list({
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        status: this.queryParam.status,
        result: this.queryParam.result,
        userName: this.queryParam.applyUserName,
        reviewCode: this.queryParam.applyCode,
        createTime1: this.queryParam.start_date,
        createTime2: this.queryParam.end_date,
      }).then((res) => {
        const pagination = { ...this.pagination }
        pagination.total = res.total
        this.pagination = pagination
        this.data = res.rows
      })
    },
    //改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.get_sel()
    },
    query() {
      this.pagination.current = 1
      this.get_sel()
    },
    result() {
      this.queryParam = {}
    },
  },
}
</script>

<style>
.btn_last {
  width: 100%;
  float: left;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

.pay_top {
  width: 100%;
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form_title {
  margin-left: 15px;
  margin-bottom: 15px;
  font-size: 17px;
  color: #999;
}

.close_icon {
  font-size: 20px;
  color: red;
  cursor: pointer;
}
</style>
